import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function getOraganizations() {
  const url = ApiUrl('organizations');
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function getUsers(orgId) {
  const url = ApiUrl('users?orgId='+orgId);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function getOraganizationDetails(orgId) {
  const url = ApiUrl('organizations/'+orgId);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function addNewOraganization(data) {
    const url = ApiUrl('organizations');
    return Call('post', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function updateOraganization(orgId,data) {
  const url = ApiUrl('organizations/'+orgId);
  return Call('put', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function getCustomerOrCarrierDetails(id) {
  const url = ApiUrl('customerAndCarrierRegistrations/'+id);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function updateCustomerOrCarrierDetails(id,data) {
  const url = ApiUrl('customerAndCarrierRegistrations/'+id);
  return Call('put', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}






